/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// PREBUY INTEGRATION: Inject CSS to control Prebuy element visibility
(function() {
  const style = document.createElement('style');
  style.id = 'prebuy-control-style';
  style.textContent = `
    .prebuy-product-text.custom-hidden {
      display: none !important;
    }
    .prebuy-product-text.custom-shown {
      display: block !important;
    }
  `;
  document.head.appendChild(style);
  window.prebuyControlStyle = style;
})();

document.addEventListener('variant:changed', function(event) {
  // Always run custom logic first, then determine if we should let Prebuy take over
  var variant = event.detail.variant;
  if (!variant) return;
  
  // Check if this specific variant is Prebuy-managed
  const hasPrebuyData = document.querySelector('.prebuy-variant-data');
  let isPrebuyVariant = false;
  
  if (hasPrebuyData) {
    try {
      const prebuyData = JSON.parse(hasPrebuyData.textContent);
      const variantData = prebuyData.variants[variant.id];
      // Only consider it Prebuy if enabled AND has stock
      if (variantData && variantData.enabled && variantData.hasVariantStock && variantData.variantInventory > 0) {
        isPrebuyVariant = true;
      }
    } catch (e) {
      // Silently handle error
    }
  }
  
  if (isPrebuyVariant) {
    // Clear custom preorder containers when Prebuy takes over
    const pdp_form = document.querySelector('.ProductForm');
    if (pdp_form) {
      const pre_order_container = pdp_form.querySelector('.pre-order-container');
      const ships_date_container = pdp_form.querySelector('.ships-date-container');
      const final_sale_ships_date_container = pdp_form.querySelector('.final-sale-ships-date-container');
      
      if (pre_order_container) pre_order_container.innerHTML = '';
      if (ships_date_container) ships_date_container.innerHTML = '';
      if (final_sale_ships_date_container) final_sale_ships_date_container.innerHTML = '';

      // Set button text for Prebuy variants
        const pre_order_btn = pdp_form.querySelector('.ProductForm__AddToCart');
        if (pre_order_btn && !pre_order_btn.disabled) {
          const buttonSpan = pre_order_btn.querySelector('span') || pre_order_btn;
          buttonSpan.textContent = 'Preorder Now';
        }
    }
    
    // Show Prebuy elements for Prebuy variants and enable Prebuy inputs
    const prebuyProductText = document.querySelector('.prebuy-product-text');
    if (prebuyProductText) {
      prebuyProductText.classList.remove('custom-hidden');
      prebuyProductText.classList.add('custom-shown');
    }
    
    // Re-enable Prebuy inputs (critical for selling plan submission!)
    const prebuySellingPlanInputs = document.querySelectorAll('.prebuy-selling-plan');
    prebuySellingPlanInputs.forEach(input => {
      input.removeAttribute('disabled');
    });
    
    const prebuyLocationInputs = document.querySelectorAll('.prebuy-location-property');
    prebuyLocationInputs.forEach(input => {
      input.removeAttribute('disabled');
    });
    
    const prebuyShippingInputs = document.querySelectorAll('.prebuy-shipping-property');
    prebuyShippingInputs.forEach(input => {
      input.removeAttribute('disabled');
    });
    
    return; // Exit early - let Prebuy handle everything
  }
  
  // Not a Prebuy variant - run custom preorder logic
  const pdp_form = document.querySelector('.ProductForm');
  const pre_order_container = pdp_form.querySelector('.pre-order-container');
  const pre_order_btn = pdp_form.querySelector('.ProductForm__AddToCart');
  const ships_date_container = pdp_form.querySelector('.ships-date-container');
  const final_sale_ships_date_container = pdp_form.querySelector('.final-sale-ships-date-container');

  if (!variant) {
    pre_order_container.innerHTML = '';
    ships_date_container.innerHTML = '';
    final_sale_ships_date_container.innerHTML = '';
    return;
  }
  
  // Check if variant exists in window.product to prevent errors
  if (!window.product || !window.product[variant.id]) {
    return;
  }
  
  const v_info = window.product[variant.id];
  
  // Forcefully hide all Prebuy elements since this is NOT a Prebuy variant
  const prebuyProductText = document.querySelector('.prebuy-product-text');
  if (prebuyProductText) {
    prebuyProductText.classList.remove('custom-shown');
    prebuyProductText.classList.add('custom-hidden');
  }
  
  // Also disable Prebuy selling plan inputs to prevent them from being submitted
  const prebuySellingPlanInputs = document.querySelectorAll('.prebuy-selling-plan');
  prebuySellingPlanInputs.forEach(input => {
    input.setAttribute('disabled', 'disabled');
    input.value = '';
  });
  
  const prebuyLocationInputs = document.querySelectorAll('.prebuy-location-property');
  prebuyLocationInputs.forEach(input => {
    input.setAttribute('disabled', 'disabled');
    input.value = '';
  });
  
  const prebuyShippingInputs = document.querySelectorAll('.prebuy-shipping-property');
  prebuyShippingInputs.forEach(input => {
    input.setAttribute('disabled', 'disabled');
    input.value = '';
  });
  
  var pre_order_html = '';
  pre_order_container.innerHTML = pre_order_html;

  var today = new Date();
  var current_year = today.getFullYear();
  var current_month = today.getMonth() + 1;
  var current_date = today.getDate();

  if (variant.available) {

    if (v_info.pre_order_enabled == null) {
      pre_order_btn.innerHTML = 'Add To Cart';
      pre_order_btn.classList.add('Button--primary');
      pre_order_btn.classList.remove('Button--secondary');
      pre_order_btn.removeAttribute('disabled');
      pre_order_btn.setAttribute('data-action', 'add-to-cart');
    } else {
      pre_order_btn.classList.remove('Button--secondary');
      pre_order_btn.classList.add('Button--primary');
      pre_order_btn.innerHTML = 'Pre-Order Now';
      pre_order_btn.removeAttribute('disabled');
      pre_order_btn.setAttribute('data-action', 'add-to-cart');

      if (v_info.pre_order_enabled && v_info.pre_order_est_date) {

        var options = { year: 'numeric', month: 'long', day: 'numeric' };
        shipping_est_date = new Date(v_info.pre_order_est_date).toLocaleDateString("en-US", options);

        pre_order_html = `
        <input type="hidden" id="pre-order-note" name="properties[PreOrder-Note]" value="Ships ${shipping_est_date}" />
        <label>Ships ${shipping_est_date}</label>`;

        pre_order_container.innerHTML = pre_order_html;
      }
    }
  } else {
    pre_order_btn.classList.remove('Button--primary');
    pre_order_btn.classList.add('Button--secondary');
    pre_order_btn.innerHTML = 'Sold Out';
    pre_order_btn.setAttribute('disabled', 'disabled');
    pre_order_btn.removeAttribute('data-action');
  }


  ships_date_container.innerHTML = v_info.ships_date ? `
    <input type="hidden" id="pre-order-note" name="properties[Ships]" value="${v_info.ships_date}">
    <div class="preorder-description">Ships ${v_info.ships_date}</div>
  ` : '';

  final_sale_ships_date_container.innerHTML = v_info.final_sale_date ? `
    <input type="hidden" id="pre-order-note" name="properties[Final-Sale]" value="Ships ${v_info.final_sale_date}">
    <div class="preorder-description">Final Sale: Ships ${v_info.final_sale_date}</div>
  ` : '';
});

// Check Prebuy inputs on initial page load and force-enable if needed
(function() {
  function checkPrebuyInputsOnLoad() {
    const sellingPlanInput = document.querySelector('.prebuy-selling-plan');
    if (sellingPlanInput) {
      const variantInput = document.querySelector('input[name="id"]');
      
      // Check if we have Prebuy data
      const prebuyDataElement = document.querySelector('.prebuy-variant-data');
      if (prebuyDataElement && variantInput?.value) {
        try {
          const prebuyData = JSON.parse(prebuyDataElement.textContent);
          const variantData = prebuyData.variants[variantInput.value];
          
          if (variantData && variantData.enabled) {
            // Force enable the input if it's disabled but should be enabled
            if (sellingPlanInput.disabled && variantData.sellingPlanId) {
              sellingPlanInput.value = variantData.sellingPlanId;
              sellingPlanInput.removeAttribute('disabled');
              sellingPlanInput.dataset.prebuyEnabled = 'true';
            }
          }
        } catch (e) {
          // Silently handle error
        }
      }
    }
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkPrebuyInputsOnLoad);
  } else {
    checkPrebuyInputsOnLoad();
  }
})();

// Removed debug logging for production

// Accordion description fucnion //
document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (event) {
    if (event.target.classList.contains('ProductMeta__AccordionTitle')) {
      const field = event.target.closest('.ProductMeta__AccordionTitle').closest('.ProductMeta__AccordionField');
      const isOpened = field.classList.contains('opened');
      field.classList.toggle('opened', !isOpened);
      field.classList.toggle('closed', isOpened);
    }
  });
});

if (!customElements.get('component-newsletter')) {
  class KlaviyoSubscribe extends HTMLElement {
    constructor() {
      super();
      this.list_id = this.dataset.listId;
      this.campaign_id = this.dataset.campaignId;
      this.dataset.klaviyo !== 'false' ? this.hasKlaviyo = true : this.hasKlaviyo = false;
      this.form = this.querySelector('form');
      this.input = this.form.querySelector('input[type="email"]');
      this.submit = this.form.querySelector('[type="submit"]');
      this.errorWrapper = this.form.querySelector('.email__error');
      this.error = this.form.querySelector('.error__text');
      this.success = this.form.querySelector('.email__input-success');
      this.wrapper = this.form.querySelector('.email__form-wrapper');
      this.companyId = 'LqrXyR';
      
      if (this.hasKlaviyo) {
        this.form.addEventListener('submit', this.klaviyoFormSubmit.bind(this));
      }
      
      this.input.addEventListener('input', () => this.hideError());
    }
    
    formData() {
      return {
        method: 'POST',
        headers: {revision: '2024-02-15', 'content-type': 'application/json'},
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Klaviyo form',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: (this.querySelector('input[type="email"]')) ? this.querySelector('input[type="email"]').value : '',
                  }
                }
              }
            },
            relationships: {list: {data: {type: 'list', id: this.list_id}}}
          }
        })
      };
    }
    
    klaviyoFormSubmit(evt) {
      evt.preventDefault()
      
      if (this.list_id === '') {
        this.showError(window.newsletterStrings.klaviyoError);
      }
      
      if (!this.inputValidation()) return;
      
      const _this = this;
      
      fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.companyId}`, this.formData())
        .then(response => {
          (response.status === 202) ? _this.showSuccess() : _this.showError()
        })
        .catch(err => {
          console.error(err);
          _this.showError()
        });
    }
    
    showSuccess() {
      if (this.success) {
        this.success.setAttribute('aria-hidden', 'false');
        this.input.classList.add('disabled');
        this.input.blur();
        this.wrapper.classList.add('success');
        this.submit.setAttribute('disabled', 'true');
        
        if (this.campaign_id) {
          this.setCampaignCookie(this.campaign_id);
        }
      }
    }
    
    setCampaignCookie(name) {
      const days = 60; // 2 months roughly equals 60 days
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = "; expires=" + date.toUTCString();
      document.cookie = `${name}=true` + expires + "; path=/";
      
      setTimeout(() => {
        document.querySelector(`.password-access[data-campaign="${this.campaign_id}"]`).classList.add('transition-hide')
      }, 1000)
      
      setTimeout(() => {
        document.querySelector(`#main`).classList.remove('hidden')
        document.querySelector(`.password-access[data-campaign="${this.campaign_id}"]`).classList.add('hidden')
        
        if (document.querySelector(`[data-section-type="recently-viewed-products"]`)) {
          Flickity.data(document.querySelector(`[data-section-type="recently-viewed-products"] .flickity-enabled`)).resize()
        }
      }, 1900)
    }
    
    
    hideError() {
      this.errorWrapper.setAttribute('aria-hidden', 'true');
      this.wrapper.classList.remove('error');
      this.submit.removeAttribute('disabled');
    }
    
    showError(errorText) {
      this.errorWrapper.setAttribute('aria-hidden', 'false');
      // check line below (was errorText = errorText ?? this.error.textContent;)
      errorText = errorText || this.error.textContent;
      this.error.textContent = errorText;
      this.wrapper.classList.remove('success');
      this.wrapper.classList.add('error');
      this.submit.setAttribute('disabled', 'true');
    }
    
    inputValidation() {
      const val = this.input.value;
      
      if (!val) return false;
      
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const result = re.test(val);
      
      if (result) {
        this.hideError();
        return true;
      } else {
        this.showError();
        return false;
      }
    }
  }
  
  customElements.define('component-newsletter', KlaviyoSubscribe);
}


/* ADD-ON SECTION */

if (!customElements.get('add-on')) {
  class AddOn extends HTMLElement {
    constructor() {
      super();
      this.addOnVariantId = null;
    }
    
    connectedCallback() {
      this.initOptionsToggle();
      this.initVariantChange();
    }
    
    initOptionsToggle() {
      const optionsOpeners = this.querySelectorAll('.ProductForm__AddOn__OptionsOpener');
      optionsOpeners.forEach((opener) => {
        opener.addEventListener('click', () => {
          const field = opener.closest('[data-add-on-options]');
          const isCurrentlyOpened = field.classList.contains('opened');
          
          this.querySelectorAll('[data-add-on-options]').forEach((f) => {
            f.classList.add('closed');
            f.classList.remove('opened');
          });
          
          if (!isCurrentlyOpened) {
            field.classList.add('opened');
            field.classList.remove('closed');
          }
          const priceElement = this.querySelector('[data-add-on-price]');
          
          priceElement.textContent = priceElement.getAttribute('data-add-on-first-price')
        });
      });
    }
    
    
    initVariantChange() {
      const addOnItems = this.querySelectorAll('[data-add-on-item]');
      addOnItems.forEach((item) => {
        const variantSelectors = item.querySelectorAll('.ProductForm__AddOn__OptionSelect');
        const currentOptionDisplay = item.querySelector('.ProductForm__AddOn__CurrentOption');
        const singleOptions = item.querySelectorAll('.ProductForm__AddOn__SingleOption');
        const addOnId = item.getAttribute('data-add-on-item');
        const checkbox = item.querySelector('[data-add-on-checkbox]');
        this.addOnVariantId = checkbox.value;
        
        const updateCurrentOptionsDisplay = () => {
          const selectedOptions = Array.from(variantSelectors).map((select) => select.options[select.selectedIndex].value);
          const fixedOptions = Array.from(singleOptions).map((singleOption) => singleOption.textContent.trim());
          const allOptions = [...fixedOptions, ...selectedOptions];
          
          const productJsonElement = document.querySelector(`#add-on-product-json-${addOnId}`);
          if (productJsonElement) {
            const productData = JSON.parse(productJsonElement.textContent);
            
            const selectedVariant = productData.variants.find((variant) => {
              const variantOptions = variant.options.join(" / ");
              const selectedOptionsString = allOptions.join(" / ");
              return variantOptions === selectedOptionsString;
            });
            
            if (selectedVariant) {
              
              const newPrice = selectedVariant.price;
              const oldPrice = selectedVariant.compareAtPrice;
              const priceElement = item.querySelector('[data-add-on-price]');
              const img = item.querySelector('.ProductForm__AddOn__Image__Wrapper img');
              const oldPriceElement = item.querySelector('[data-add-on-old-price]');
              
              if (selectedVariant.image) {
                img.src = selectedVariant.image;
              }
              if (priceElement && priceElement.textContent !== newPrice) {
                priceElement.textContent = newPrice;
                
                if (oldPrice && oldPriceElement) {
                  oldPriceElement.textContent = oldPrice;
                  oldPriceElement.style.display = 'block';
                } else if (oldPriceElement) {
                  oldPriceElement.style.display = 'none';
                }
              }
              this.addOnVariantId = selectedVariant.variantId;
              
              if (checkbox) {
                checkbox.value = this.addOnVariantId;
              }
            }
          }
          
          if (currentOptionDisplay) {
            currentOptionDisplay.textContent = allOptions.join(' / ');
          }
        };
        
        variantSelectors.forEach((select) => {
          select.addEventListener('change', updateCurrentOptionsDisplay);
        });
      });
    }
  }
  
  customElements.define('add-on', AddOn);
}

// Intercept cart add requests to inject selling plan if missing
(function() {
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const [url, options] = args;
    
    if (typeof url === 'string' && url.includes('/cart/add')) {
      if (options && options.body) {
        try {
          const bodyData = JSON.parse(options.body);
          
          if (bodyData.items && bodyData.items[0]) {
            const firstItem = bodyData.items[0];
            
            // Check if selling plan is missing but should be present
            if (!firstItem.selling_plan) {
              // Check if we have an enabled selling plan input
              const sellingPlanInput = document.querySelector('.prebuy-selling-plan');
              if (sellingPlanInput && !sellingPlanInput.disabled && sellingPlanInput.value) {
                // Add selling plan to the first item
                firstItem.selling_plan = sellingPlanInput.value;
                
                // Update the request body
                options.body = JSON.stringify(bodyData);
              }
            }
          }
        } catch (e) {
          // Silently handle error
        }
      }
    }
    
    return originalFetch.apply(this, args);
  };
})();

// Handle initial page load to ensure Prebuy inputs are enabled for initial Prebuy variants
document.addEventListener('DOMContentLoaded', function() {
  // Small delay to ensure Prebuy system has initialized
  setTimeout(function() {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) {
      const initialVariantId = variantInput.value;
      
      // Check if initial variant is Prebuy-managed
      const hasPrebuyData = document.querySelector('.prebuy-variant-data');
      let isPrebuyVariant = false;
      
      if (hasPrebuyData) {
        try {
          const prebuyData = JSON.parse(hasPrebuyData.textContent);
          const variantData = prebuyData.variants[initialVariantId];
          if (variantData && variantData.enabled && variantData.hasVariantStock && variantData.variantInventory > 0) {
            isPrebuyVariant = true;
          }
        } catch (e) {
          // Silently handle error
        }
      }
      
      if (isPrebuyVariant) {
        const pre_order_btn = document.querySelector('.ProductForm__AddToCart');
        if (pre_order_btn && !pre_order_btn.disabled) {
          const buttonSpan = pre_order_btn.querySelector('span') || pre_order_btn;
          buttonSpan.textContent = 'Preorder Now';
        }
        
        // Show Prebuy elements for Prebuy variants
        const prebuyProductText = document.querySelector('.prebuy-product-text');
        if (prebuyProductText) {
          prebuyProductText.classList.remove('custom-hidden');
          prebuyProductText.classList.add('custom-shown');
        }
        
        // Re-enable Prebuy inputs for Prebuy variants
        const prebuySellingPlanInputs = document.querySelectorAll('.prebuy-selling-plan');
        prebuySellingPlanInputs.forEach(input => {
          input.removeAttribute('disabled');
        });
        
        const prebuyLocationInputs = document.querySelectorAll('.prebuy-location-property');
        prebuyLocationInputs.forEach(input => {
          input.removeAttribute('disabled');
        });
        
        const prebuyShippingInputs = document.querySelectorAll('.prebuy-shipping-property');
        prebuyShippingInputs.forEach(input => {
          input.removeAttribute('disabled');
        });
      } else {
        // Keep Prebuy elements hidden (they're hidden by default CSS)
        const prebuyProductText = document.querySelector('.prebuy-product-text');
        if (prebuyProductText) {
          prebuyProductText.classList.remove('custom-shown');
          prebuyProductText.classList.add('custom-hidden');
        }
        
        // Disable Prebuy inputs
        const prebuySellingPlanInputs = document.querySelectorAll('.prebuy-selling-plan');
        prebuySellingPlanInputs.forEach(input => {
          input.setAttribute('disabled', 'disabled');
          input.value = '';
        });
        
        const prebuyLocationInputs = document.querySelectorAll('.prebuy-location-property');
        prebuyLocationInputs.forEach(input => {
          input.setAttribute('disabled', 'disabled');
          input.value = '';
        });
        
        const prebuyShippingInputs = document.querySelectorAll('.prebuy-shipping-property');
        prebuyShippingInputs.forEach(input => {
          input.setAttribute('disabled', 'disabled');
          input.value = '';
        });
        
        // TRIGGER variant:changed event to run legacy preorder logic
        const variantData = window.product && window.product[initialVariantId];
        
        if (variantData) {
          document.dispatchEvent(new CustomEvent('variant:changed', {
            detail: {
              variant: {
                id: initialVariantId,
                available: variantData.inventory_quantity > 0,
                inventory_quantity: variantData.inventory_quantity,
                pre_order_enabled: variantData.pre_order_enabled,
                pre_order_est_date: variantData.pre_order_est_date
              }
            }
          }));
        } else {
          // Retry with longer delay if window.product not ready yet
          setTimeout(function() {
            const retryVariantData = window.product && window.product[initialVariantId];
            if (retryVariantData) {
              document.dispatchEvent(new CustomEvent('variant:changed', {
                detail: {
                  variant: {
                    id: initialVariantId,
                    available: retryVariantData.inventory_quantity > 0,
                    inventory_quantity: retryVariantData.inventory_quantity,
                    pre_order_enabled: retryVariantData.pre_order_enabled,
                    pre_order_est_date: retryVariantData.pre_order_est_date
                  }
                }
              }));
            }
          }, 300);
        }
      }
    }
  }, 200); // Delay to ensure all scripts have loaded
});

// ADDITIONAL FIX: Always trigger variant:changed on page load for legacy preorder button text
window.addEventListener('load', function() {
  setTimeout(function() {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput && variantInput.value) {
      const variantId = variantInput.value;
      
      // Get variant data from product-form.liquid script
      const productDataElement = document.querySelector('script[data-product-json]');
      if (productDataElement) {
        try {
          const productData = JSON.parse(productDataElement.textContent);
          const product = productData.product;
          const currentVariant = product.variants.find(v => v.id.toString() === variantId.toString());
          
          if (currentVariant) {
            document.dispatchEvent(new CustomEvent('variant:changed', {
              detail: {
                variant: currentVariant
              }
            }));
          }
        } catch (e) {
          // Silently handle error
        }
      }
    }
  }, 100);
});
